import React, { forwardRef } from 'react';
import { css, cx } from '@emotion/css';
import { IconClose, IconConfirmation, IconInformation, IconWarning, theme, } from '@contrast-security-inc/design-system-foundations';
import { Text } from '@contrast-security-inc/design-system-typography';
import { Stack } from '@contrast-security-inc/design-system-layouts';
import { IconButton } from '@contrast-security-inc/design-system-buttons';
const rootContainerStyle = (inline, getBgColor, variant) => css `
  border-radius: ${inline ? 4 : 0}px;
  padding: 16px;
  background-color: ${getBgColor(variant)};
  box-shadow: ${theme.shadow.lt};
`;
export const MessageBanner = forwardRef(({ testId, inline = true, variant, message, title, onClose, className, ...rest }, ref) => {
    return (React.createElement(Stack, { "data-testid": testId, "aria-live": "polite", alignItems: "flex-start", justifyContent: "space-between", spacing: "8px", className: cx(rootContainerStyle(inline, getBgColor, variant), className), ref: ref, ...rest },
        React.createElement(Stack, { spacing: "8px" },
            React.createElement(IconByVariant, { variant: variant, testId: testId }),
            React.createElement(Stack, { flexDirection: "column", spacing: "4px" },
                title && React.createElement(Text, { font: "bodyStrong" }, title),
                React.createElement(Text, { font: "body" }, message))),
        onClose && (React.createElement(IconButton, { Icon: IconClose, size: "md", "aria-label": "Close message banner", testId: testId && `${testId}-close`, onClick: onClose, variant: "secondary" }))));
});
const IconByVariant = ({ variant, testId }) => {
    switch (variant) {
        case 'error':
            return React.createElement(IconWarning, { size: "md", color: "red50", testId: testId && `${testId}-error-icon` });
        case 'warning':
            return React.createElement(IconWarning, { size: "md", color: "yellow50", testId: testId && `${testId}-warning-icon` });
        case 'success':
            return React.createElement(IconConfirmation, { size: "md", color: "green50", testId: testId && `${testId}-success-icon` });
        case 'info':
            return React.createElement(IconInformation, { size: "md", color: "blue50", testId: testId && `${testId}-info-icon` });
    }
};
const getBgColor = (variant) => {
    switch (variant) {
        case 'error':
            return theme.color.red10;
        case 'warning':
            return theme.color.yellow10;
        case 'success':
            return theme.color.green10;
        case 'info':
            return theme.color.blue10;
    }
};
MessageBanner.displayName = 'MessageBanner';
